const EnumFuncionalidade = {
  CARTAO: '3'
}

export { EnumFuncionalidade }
